var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{class:[_vm.s.icon, {[_vm.s.smallIcon]: _vm.small, [_vm.className]: _vm.className}],on:{"click":function($event){return _vm.$emit('clicked', $event)}}},[_c('use',{attrs:{"href":`#${_vm.icon}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }